// extracted by mini-css-extract-plugin
module.exports = {"wide":"Video_wide__PF_dY","video":"Video_video__Spk90"};